import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

function getInitials(name) {
  if (!name) {
    return '?';
  }
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function UserContextPanel({ onWorkspaceSelect, className = '' }) {
  const { user, account, memberships } = useAuth();

  if (!user) {
    return null;
  }

  const hasMultipleWorkspaces = memberships.length > 1;

  return (
    <div className={`px-4 py-3 border-b border-surface-border ${className}`}>
      <div className="flex items-center gap-3">
        <div
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-forge-100 text-forge-700 text-sm font-semibold"
          aria-hidden
        >
          {getInitials(user.name)}
        </div>
        <div className="min-w-0">
          <div className="text-sm font-medium text-content-primary truncate">{user.name}</div>
          <div className="text-xs text-content-muted truncate">{user.email}</div>
        </div>
      </div>

      {account && (
        <div className="mt-3">
          <div className="text-[11px] font-medium uppercase tracking-wide text-content-muted mb-1.5">
            Workspace
          </div>
          {hasMultipleWorkspaces ? (
            <div className="space-y-1">
              {memberships.map((membership) => {
                const isActive = membership.account_id === account.id;
                const label = membership.account?.name || membership.account_id;
                return (
                  <button
                    key={membership.account_id}
                    type="button"
                    onClick={() => onWorkspaceSelect?.(membership.account_id)}
                    className={`w-full text-left rounded-lg px-2.5 py-2 text-sm transition-colors ${
                      isActive
                        ? 'bg-forge-50 text-forge-700 font-medium'
                        : 'text-content-primary hover:bg-slate-50'
                    }`}
                  >
                    {label}
                  </button>
                );
              })}
            </div>
          ) : (
            <div className="text-sm text-content-secondary truncate">{account.name}</div>
          )}
        </div>
      )}
    </div>
  );
}

export { getInitials };
